<template>
  <div class="address-info-box" v-if="network && address">
    <div class="title">NFT receiving address</div>
    <div class="address-info">
      <div class="network">
        <span class="label">Network:</span>
        <span class="val">{{ network }}</span>
      </div>
      <div class="address">
        <span class="label">Address:</span>
        <span class="val">{{ address }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AddressInfo",
  props: {
    network: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    routerPath: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
.address-info-box {
  margin: 0.16rem 0;
  .title {
    font-family: Regular;
    font-size: 0.13rem;
    font-weight: 700;
    line-height: 0.16rem;
    text-align: left;
    margin-bottom: 0.12rem;
  }
}
.address-info {
  border: 1px solid #e6e8eb;
  padding: 0 0.12rem;
  border-radius: 0.08rem;

  .network,
  .address {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    font-family: Regular;
    font-size: 0.13rem;
    font-weight: 400;
    line-height: 0.16rem;
    text-align: left;
    padding: 0.12rem 0;

    .label {
      width: 0.8rem;
    }
    .val {
      flex: 1;
      word-break: break-all;
      text-align: right;
    }
  }
  .address {
    border-top: 1px solid #e6e8eb;
  }
}
</style>
